import * as React from "react";
import { Input, Label } from "reactstrap";
import classnames from 'classnames';

class AgreementCheckboxField extends React.Component<any> {
  render() {
    const { componentLabel, className, disabled, value, onClick, ...props } = this.props;
    return (
      <Label check className={classnames("d-block", className, disabled && "disabled")}>
        <Input type="checkbox" disabled={disabled} checked={value} onClick={onClick} {...props} />
        {componentLabel}
      </Label>
    );
  }
}

export default AgreementCheckboxField;
